/* global MESSAGING_THESCORE_URL */
import React from 'react';
import logEvent from '~/util/analytics';
import NewsletterCard from '~/components/NewsletterCard/NewsletterCard';

const trackEvent = league => {
  logEvent('newsletter', { league, type: 'subscribe' });
};

class NewsletterContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      message: '',
    };
    this.subscribe = this.subscribe.bind(this);
  }

  subscribe(email) {
    fetch(`${MESSAGING_THESCORE_URL}/newsletter/subscribe`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: `email=${email}`,
    })
      .then(response => response.text().then(text => (text ? JSON.parse(text) : {})))
      .then(res => {
        if (res.error) {
          this.setState({ message: res.error });
        } else {
          this.setState({
            message: 'Thank you! Check your inbox for confirmation.',
          });
          trackEvent(this.props.league);
        }
      })
      .catch(err => {
        this.setState({ message: err });
      });
  }

  render() {
    return <NewsletterCard message={this.state.message} subscribe={this.subscribe} />;
  }
}

export default NewsletterContainer;
